import { useLocation } from "react-router-dom";

const SECTION_LINKS = [
  { label: "The X", href: "#the-x" },
  { label: "Protocol", href: "#how-it-works" },
  { label: "Network", href: "#who" },
  { label: "Founding 100", href: "#founding-100" },
  { label: "FINDX AI", href: "#findx-ai" },
];

const ROUTE_LINKS = [
  { label: "Opportunities", href: "/opportunities" },
  { label: "Post to the X", href: "/post" },
];

export const Footer = () => {
  const { pathname } = useLocation();
  const prefix = pathname === "/" ? "" : "/";

  return (<footer data-testid="footer" className="relative border-t border-white/10 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-10">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div>
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 grid place-items-center border border-[#00F0FF]/50 font-display font-extrabold text-lg text-[#00F0FF]">
              X
            </span>
            <span className="font-display font-bold tracking-[0.2em] text-sm text-slate-100">FINDXCHANGE</span>
          </div>
          <p className="mt-4 font-mono-accent text-[11px] tracking-[0.3em] text-slate-500">
            FIND. CONNECT. GROW.
          </p>
        </div>
        <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-links">
          {SECTION_LINKS.map((l) => (
            <a
              key={l.href}
              href={`${prefix}${l.href}`}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="font-mono-accent text-[11px] uppercase tracking-[0.25em] text-slate-500 hover:text-[#00F0FF] transition-colors"
            >
              {l.label}
            </a>
          ))}
          {ROUTE_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="font-mono-accent text-[11px] uppercase tracking-[0.25em] text-slate-500 hover:text-[#00F0FF] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2.5" data-testid="footer-status">
          <span className="relative flex w-2 h-2">
            <span className="absolute inline-flex w-full h-full bg-[#00F0FF] animate-node-ping" />
            <span className="relative inline-flex w-2 h-2 bg-[#00F0FF]" />
          </span>
          <span className="font-mono-accent text-[10px] tracking-[0.3em] text-slate-500">NETWORK STATUS: BUILDING</span>
        </div>
      </div>
    </div>
    <div className="relative select-none pointer-events-none px-2 overflow-hidden" aria-hidden="true">
      <p className="font-display font-extrabold uppercase text-center leading-[0.8] tracking-tight text-outline text-[10.5vw] whitespace-nowrap -mb-[2.2vw]">
        FINDXCHANGE
      </p>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <span className="font-mono-accent text-[10px] tracking-[0.25em] text-slate-600">© 2026 FINDXCHANGE. ALL RIGHTS RESERVED.</span>
        <span className="font-mono-accent text-[10px] tracking-[0.25em] text-slate-600">WHERE BOTH SIDES MEET — ✕</span>
      </div>
    </div>
  </footer>
  );
};
